import { Grid, TextField, Typography } from "@mui/material";
import { Controller, FieldError, useFormContext } from "react-hook-form";
import validateSSN from "../../../helpers/validateSSN";

type Props = {
  name: string;
  required?: { value: boolean; message: string };
  edit?: boolean;
  error?: FieldError;
  helperText?: string;
};

const SsnField = ({
  name,
  required = { value: true, message: "" },
  edit = true,
  error,
  helperText,
}: Props) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required,
        validate: (value) => validateSSN(value, undefined),
      }}
      render={({ field: { name, value, onChange } }) =>
        edit ? (
          <>
            <Grid alignItems="center" item container xs={3}>
              <TextField
                fullWidth
                name={name}
                value={value}
                onChange={onChange}
                error={Boolean(error)}
                size="small"
              />
            </Grid>
            {error && helperText && (
              <Grid xs={12} ml="14px">
                <Typography
                  color="error"
                  fontSize="12px"
                  letterSpacing="0.03333em"
                >
                  {helperText}
                </Typography>
              </Grid>
            )}
          </>
        ) : (
          <Typography>{value}</Typography>
        )
      }
    />
  );
};
export default SsnField;
